import { DEFAULT_GROUP } from "../context/context";
import { GET_GROUP_OPTIONS, CLEAR_GROUP_OPTIONS, } from "./types";
export const groupOptionReducer = (state = DEFAULT_GROUP, action) => {
    switch (action.type) {
        case GET_GROUP_OPTIONS: {
            return [...action.payload];
        }
        case CLEAR_GROUP_OPTIONS: {
            return [];
        }
        default: {
            return state;
        }
    }
};
